module.exports = __webpack_public_path__ + "img/swap-arrow.3aa0c7de.svg";